import type { CommunityPost } from '~/interfaces/community';

// Content match, whitespace-insensitive (origin isn't serialized);
// a newsletter title edited after sync diverges and both titles render again — by design.
export const isDuplicateEmbedTitle = (post: CommunityPost): boolean =>
  post.attachable?.type === 'post' && post.title.trim() === post.attachable.web_title.trim();
